<div class="loader-container">
    <img alt="loader" class="loader-icon" src="assets/images/loader.gif" [ngClass]="{'loader-icon-centered' : fromEquipBuilder}" />
</div>
